var map = {
	"./AddAllergy.vue": "b530",
	"./AddDiseases.vue": "6c4b",
	"./AddEvent.vue": "6738",
	"./AddInspection.vue": "5011",
	"./AddMedicine.vue": "114f",
	"./AddMedicineReciept.vue": "aeac",
	"./AddParameter.vue": "b367",
	"./AddSymptom.vue": "21e9",
	"./ConfirmationModal.vue": "5dde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7548";